module.exports = __webpack_public_path__ + "assets/img/tit2.cedddea3.png";